import { Breadcrumbs, makeStyles, Grid, Button } from "@material-ui/core";
import React, { useState } from "react";
import { Search, PersonAdd } from "@material-ui/icons";
import { MENU_PROVEEDORES } from "../../../../utils/constants";
import ProveedoresConsulta from "./ProveedoresConsulta";
import { ProveedoresIngreso} from "./ProveedoresIngreso";
import { useDispatch } from "react-redux";
import { desSeleccionarProveedor } from "../../../../actions/compras/ProveedoresAction";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  tabs: {
    marginTop: "1rem",
  },
  button: {
    textAlign: "center",
  },
}));

//breadscrumbs que se renderizan
// const breads = [
//   {
//     titulo: () => (
//       <>
//         <Search />
//         Consultar Proveedores
//       </>
//     ),
//     body: <ProveedoresConsulta />,
//   },
//   {
//     titulo: () => (
//       <>
//         <PersonAdd />
//         Ingreso / Modificación de Proveedores
//       </>
//     ),
//     body: <ProveedoresIngreso />,
//   },
// ];

const ProveedoresScreen = () => {
  const classes = useStyles();
  const [menu, setMenu] = useState(0);
  const dispatch = useDispatch(); 

  // useEffect(() => {
  //   return(
  //     dispatch(desSeleccionarProveedor())
  //   )

  // }, [menu])

  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={1}
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid item xs={12} styles={{ padding: 5 }}>
          <Grid container>
            <Grid item xs={12}>
              <Breadcrumbs style={{ color: "#fafafa" }}>
                <Button
                  color={
                    menu === MENU_PROVEEDORES.CONSULTA ? "default" : "inherit"
                  }
                  onClick={(e) => {
                    setMenu(MENU_PROVEEDORES.CONSULTA);
                    dispatch(desSeleccionarProveedor())
                  }}
                >
                  <Search />
                  Consultar Proveedores
                </Button>

                <Button
                  color={
                    menu === MENU_PROVEEDORES.INGRESO ? "default" : "inherit"
                  }
                  onClick={(e) => {
                    setMenu(MENU_PROVEEDORES.INGRESO);
                    dispatch(desSeleccionarProveedor())
                  }}
                >
                  <PersonAdd />
                  Ingreso / Modificación de Proveedores
                </Button>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12}>
              <Grid container justify="center" className={classes.root}>
                {menu === MENU_PROVEEDORES.CONSULTA && (
                  <ProveedoresConsulta Menu={menu} />
                )}
                {menu === MENU_PROVEEDORES.INGRESO && (
                  <ProveedoresIngreso Menu={menu} />
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default ProveedoresScreen;
